module.exports = __webpack_public_path__ + "components/guide-page/static/icon-boots-4ea2da7240ad4582b4272e370bc891f0.svg";